"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Icons = _interopRequireDefault(require("../Common/Icons"));

var _iconsMaterial = require("@mui/icons-material");

var _material = require("@mui/material");

var _reactSwipeableViews = _interopRequireDefault(require("react-swipeable-views"));

var _reactSwipeableViewsUtils = require("react-swipeable-views-utils");

var _UqButton = _interopRequireDefault(require("@uniqore/wrapper/UqButton"));

var _wrapper = require("@uniqore/wrapper");

var _Layout = _interopRequireDefault(require("../Layout"));

var _CarouselItem = require("./CarouselItem");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const AutoPlaySwipeableViews = (0, _reactSwipeableViewsUtils.autoPlay)(_reactSwipeableViews.default);
const MainContainer = (0, _material.styled)(_wrapper.UqGrid, {
  name: 'MainContainer'
})(props => ({
  height: '100%',
  flexWrap: 'nowrap',
  background: props.background || 'initial',
  [props.theme.breakpoints.up('sm')]: {
    paddingTop: 24,
    borderRadius: props.borderRadius || 20,
    boxShadow: props.shadow || '0px 8px 12px rgba(0, 44, 56, 0.08)'
  }
}));
const ActionContainer = (0, _material.styled)(_wrapper.UqStack, {
  name: 'ActionContainer'
})(props => ({
  [props.theme.breakpoints.up('sm')]: {
    marginTop: 28,
    marginLeft: 32,
    marginRight: 32,
    marginBottom: 16
  }
}));
const Stepper = (0, _material.styled)(_wrapper.UqMobileStepper, {
  name: 'Stepper'
})(() => ({
  '.MuiMobileStepper-dot': {
    margin: '0 4px'
  }
}));

const Onboarding = ({
  actionComponents = [],
  carouselItems = [],
  actionDirection = 'column',
  buttonsColor = 'primary',
  layoutProps = {},
  useLayout = true,
  autoplay = false,
  playInterval = 3000,
  background,
  containerBackground,
  borderRadius,
  shadow
}) => {
  const [index, setIndex] = _react.default.useState(0);

  const calculateIndex = (index, itemsLength) => {
    return index < 0 ? itemsLength - 1 : index >= itemsLength ? 0 : index;
  };

  const handleIndexChange = newIndex => {
    setIndex(calculateIndex(newIndex, carouselItems.length));
  };

  const BackStep = _react.default.createElement(_wrapper.UqIconButton, {
    onClick: () => handleIndexChange(index - 1),
    size: "small",
    "aria-label": "back"
  }, _react.default.createElement(_iconsMaterial.ArrowBackIos, {
    fontSize: "small"
  }));

  const NextStep = _react.default.createElement(_wrapper.UqIconButton, {
    onClick: () => handleIndexChange(index + 1),
    size: "small",
    "aria-label": "forward"
  }, _react.default.createElement(_iconsMaterial.ArrowForwardIos, {
    fontSize: "small"
  }));

  return _react.default.createElement(_Layout.default, _extends({
    useCenteredView: useLayout,
    showFooter: useLayout,
    containerBackground: containerBackground
  }, layoutProps, {
    paddingBottom: 0
  }), _react.default.createElement(MainContainer, {
    container: true,
    direction: "column",
    justifyContent: "flex-end",
    background: background,
    borderRadius: borderRadius,
    shadow: useLayout ? 'none' : shadow
  }, _react.default.createElement(_wrapper.UqBox, {
    item: true,
    style: {
      marginLeft: 16,
      marginRight: 16
    }
  }, _react.default.createElement(AutoPlaySwipeableViews, {
    enableMouseEvents: true,
    autoplay: autoplay,
    interval: playInterval,
    index: index,
    onChangeIndex: handleIndexChange,
    containerStyle: {
      alignItems: 'flex-end'
    },
    slideStyle: {
      height: 'min-content'
    }
  }, carouselItems.map((props, key) => _react.default.createElement(_CarouselItem.CarouselItem, _extends({
    key: key
  }, props))))), actionComponents.length > 0 && _react.default.createElement(ActionContainer, {
    direction: actionDirection
  }, actionComponents.map((button, key) => {
    if (_react.default.isValidElement(button)) return button;
    const {
      onClick,
      text,
      variant,
      color,
      size,
      disabled,
      fullWidth,
      startIcon,
      endIcon
    } = button;
    return _react.default.createElement(_UqButton.default, {
      key: key,
      color: color === 'inherit' ? buttonsColor : color || buttonsColor,
      variant: variant || 'contained',
      size: size || 'large',
      disabled: disabled,
      fullWidth: fullWidth !== false,
      onClick: onClick,
      startIcon: startIcon ? _react.default.createElement(_Icons.default[startIcon]) : null,
      endIcon: endIcon ? _react.default.createElement(_Icons.default[endIcon]) : null
    }, text);
  })), carouselItems.length > 1 && _react.default.createElement(_wrapper.UqBox, {
    item: true,
    alignSelf: "center"
  }, _react.default.createElement(Stepper, {
    variant: "dots",
    steps: carouselItems.length,
    nextButton: NextStep,
    backButton: BackStep,
    activeStep: index,
    sx: {
      position: 'relative'
    }
  }))));
};

var _default = Onboarding;
exports.default = _default;